module.exports = __webpack_public_path__ + "assets/img/09.3531b69d.png";